import { getSupabaseClient } from "../providers/supabase/supabase";

// Shared telephony helpers (used by both the shared-Device TelephonyProvider and
// the standalone useTelephony fallback). voice-token mints an incoming-capable
// Twilio access token whose identity = public.users.id.

export async function functionUrl(name: string) {
  return `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/${name}`;
}

export async function authHeaders() {
  const { data } = await getSupabaseClient().auth.getSession();
  const token = data.session?.access_token;
  return {
    apikey: import.meta.env.VITE_SB_PUBLISHABLE_KEY as string,
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

// Fetch a fresh Voice access token (1h TTL). Throws on failure.
export async function fetchVoiceToken(): Promise<string> {
  const res = await fetch(await functionUrl("voice-token"), { method: "POST", headers: await authHeaders() });
  if (!res.ok) throw new Error(`voice-token ${res.status}`);
  const { token } = await res.json();
  return token as string;
}
